<template>
	<v-app class="app__root" v-if="!isPolicyPage">
		<header-component class="position-fixed" />

		<!-- TODO: check the max-width -->
		<div class="app__page mb-8">
			<div style="width: 100%; max-width: 1200px; padding: 0 16px;">
				<router-view />
			</div>
		</div>

		<BottomNavigation v-if="!isDesktopDevice" />
		<FooterComponent />
		<UserLiveActivitiesBottomBar />

		<div v-if="!isPolicyPage">
			<PhoneVerification></PhoneVerification>
		</div>

		<auth-dialog :dialogVisible="dialogVisible" @update:dialogVisible="updateDialogVisible" />
		<SignupSteps />
		<ForgotPasswordSteps />
	</v-app>

	<!-- TeleportSnackbar component for all routes -->
	<TeleportSnackbar />

	<!-- Policy pages are rendered directly through router-view -->
	<router-view v-if="isPolicyPage" />
</template>

<script>
import { computed, provide } from "vue";
import { isDesktop } from "@/utils/utils";
import { AppConfigs } from "@/app.configs";
import { useAuthStore } from "@/store/AuthStore";
import { useAppConfigStore } from "@/store/AppConfigStore";
import TeleportSnackbar from "@/components/Common/Teleport-Snackbar.vue";
import FooterComponent from "@/components/Common/Footer-Component.vue";
import AuthDialog from "@/components/Auth/AuthDialog/AuthDialog.vue";
import { LiveUserActivityStore } from '@/store/liveUserActivityStore';
import HeaderComponent from "@/components/Header/Header-Component.vue";
import BottomNavigation from "@/components/Common/Bottom-Navigation.vue";
import SignupSteps from "@/components/Auth/Signup/SignupSteps/Signup-Steps.vue";
import PhoneVerification from "@/components/PhoneVerification/Phone-Verification.vue";
import ForgotPasswordSteps from '@/components/Auth/ForgotPassword/Forgot-Password-Steps.vue';
import UserLiveActivitiesBottomBar from "@/components/UserActivity/Users-Live-Activity-Bottom-Bar.vue";

/* global FB */

export default {
	name: "App",
	components: {
		AuthDialog,
		SignupSteps,
		HeaderComponent,
		FooterComponent,
		TeleportSnackbar,
		BottomNavigation,
		PhoneVerification,
		ForgotPasswordSteps,
		UserLiveActivitiesBottomBar,
	},
	computed: {
		isPolicyPage() {
			const policyPaths = ['/terms', '/privacy', '/cookie', '/faq', '/tos', '/policy'];
			return policyPaths.includes(this.$route.path);
		}
	},
	setup() {
		const isDesktopDevice = isDesktop();

		// initialize auth store
		const authStore = useAuthStore();

		const dialogVisible = computed(() => authStore.loginDialogVisible);
		provide('openDialog', dialogVisible)

		const updateDialogVisible = (value) => {
			authStore.setLoginDialogVisible(value);
		};

		return {
			authStore,
			dialogVisible,
			isDesktopDevice,
			updateDialogVisible,
		};
	},
	mounted() {
		// Initialize facebook sdks, with app ids.
		(function (d, s, id) {
			var js,
				fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			js = d.createElement(s);
			js.id = id;
			js.src = "https://connect.facebook.net/en_US/sdk.js";
			fjs.parentNode.insertBefore(js, fjs);
		})(document, "script", "facebook-jssdk");

		window.fbAsyncInit = function () {
			FB.init({
				appId: AppConfigs.facebookAppId,
				cookie: true,
				xfbml: true,
				version: "v17.0",
			});
			FB.AppEvents.logPageView();
		};
	}
};
</script>

<style lang="scss">
@use "@/assets/scss/BOUNTYHUNTER.scss" as *;
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500;600;700&display=swap");

.app {
	&__root {
		@extend .background-primary;
	}

	&__page {
		display: flex;
		justify-content: center;
		margin-top: calc(vars.get-map-value(vars.$header, height, desktop) + 20px);

		@media screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
			margin-top: calc(vars.get-map-value(vars.$header, height, tab) + 20px);
		}
	}
}

.fab {
	display: flex;
	flex-direction: column-reverse;

	position: fixed;
	bottom: 60px;
	right: 60px;
}
</style>
